import { AdditionalRequirements, NurseType } from '../constants';

export const checkShiftRequiresMedpass = (shift) => {
  if (!shift) {
    return false;
  }
  const nurseTypeMustMedPass = [NurseType.LPN, NurseType.RN].includes(shift.nurseType);
  return (shift.additionalRequirements || []).includes(AdditionalRequirements.MED_PASS) || nurseTypeMustMedPass;
};
